import { render, staticRenderFns } from "./AbsencesVirtualScroller.vue?vue&type=template&id=1d575cb8&scoped=true&"
import script from "./AbsencesVirtualScroller.vue?vue&type=script&lang=js&"
export * from "./AbsencesVirtualScroller.vue?vue&type=script&lang=js&"
import style0 from "./AbsencesVirtualScroller.vue?vue&type=style&index=0&id=1d575cb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d575cb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VIcon,VVirtualScroll})
